<template>
  <base-modal
    :id="modalId"
    :ok-handler="okHandler"
    :title="title"
    :ok-button-text="okButtonText"
    :ok-button-class="okButtonClass"
  >
    <div>
      Are you sure you want to delete user <strong>{{ userName }}</strong>?
    </div>
  </base-modal>
</template>

<script>
import BaseModal from './BaseModal';

export default {
  name: 'DeleteUserConfirmationModal',
  components: { BaseModal },
  props: {
    title: {
      type: String,
      default: 'Delete User',
    },
    content: {
      type: String,
      default: '',
    },
    okButtonText: {
      type: String,
      default: 'OK',
    },
    okButtonClass: {
      type: String,
      default: 'btn-warning',
    }
  },
  data() {
    return {
      modalId: 'delete-user-confirmation-modal',
    }
  },
  computed: {
    userToDelete: function()  {
      return this.$store.getters.getUserToDelete;
    },
    userName: function() {
      let user = this.userToDelete;
      console.log('this.userToDelete: ', this.userToDelete);
      return user && user.name ? user.name : '';
    },
  },
  methods: {
    okHandler: function() {
      const payload = {
        vm: this,
        user: this.userToDelete,
      };
      this.$store.dispatch('deleteUser', payload);
    },
  },
}
</script>
